import service from "./service"

export default ($http, context) => ({
  httpGetAvandTransactionCount(item) {
    const url = `/stat?code=avand_transaction_count_${item.duration}_${item.timePeriod}&params[account_number]=${item.account}`
    return service.get($http, context, url)
  },
  httpGetAvandTransactionCreditAndDebit(item) {
    const url = `/stat?code=avand_transaction_sum_of_credit_and_debit_${item.duration}_${item.timePeriod}&params[account_number]=${item.account}`
    return service.get($http, context, url)
  },
  httpGetAvandTransactionMinAndMaxBalance(item) {
    const url = `/stat?code=avand_transaction_min_and_max_balance_${item.duration}_${item.timePeriod}&params[account_number]=${item.account}`
    return service.get($http, context, url)
  },
})
